import React from "react";
import "./style.css";
import { Collapse } from "antd";
import { useTranslation } from "../../i18n/LanguageContext";

const About = () => {
    const { t } = useTranslation();

    const faqItems = t("about.faq").map((item, i) => ({
        key: String(i),
        label: item.q,
        children: <p style={{ paddingInlineStart: 24 }}>{item.a}</p>,
    }));

    return (
        <div className="main-content-wrapper">
            <div className="about-content">
                <h2>{t("page.about.title")}</h2>
                <p>{t("about.intro.p1")}</p>
                <ul className="about-list">
                    {t("about.intro.items").map((li, i) => (
                        <li key={i}>{li}</li>
                    ))}
                </ul>
                <p>{t("about.intro.p2")}</p>
                <h2>{t("about.faqTitle")}</h2>
                <Collapse
                    className="collapseAbout"
                    items={faqItems}
                    bordered={false}
                    accordion
                    collapsible={"header"}
                />
            </div>
        </div>
    );
};

export default About;
